"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getMinFractionDigits = getMinFractionDigits;
exports.toCurrency = toCurrency;
var _react = _interopRequireDefault(require("react"));
function isFloat(value) {
  return value % 1 !== 0;
}
function getMinFractionDigits(value) {
  return isFloat(value) ? 2 : 0;
}
function toCurrency(amount) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  var maxFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var minFractionDigits = arguments.length > 3 ? arguments[3] : undefined;
  var minimumFractionDigits = minFractionDigits || getMinFractionDigits(amount);
  var result = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: maxFractionDigits,
    minimumFractionDigits: minimumFractionDigits
  }).format(amount);
  return currency === 'CAD' ? result.replace('CA$', 'CAD ') : result;
}
var HBCurrency = function HBCurrency(_ref) {
  var amount = _ref.amount,
    currency = _ref.currency,
    maxFractionDigits = _ref.maxFractionDigits,
    minFractionDigits = _ref.minFractionDigits;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, toCurrency(amount, currency, maxFractionDigits, minFractionDigits));
};
var _default = exports["default"] = HBCurrency;
//# sourceMappingURL=HBCurrency.js.map